module.exports = __webpack_public_path__ + "sea.478b8c6111d8930c12ca.png";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/images/themes/footer/style03/sea.png
// module id = ../../../../../src/assets/images/themes/footer/style03/sea.png
// module chunks = 2